"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInputState = void 0;
var tslib_1 = require("tslib");
var input_state_1 = require("./input.state");
var RadioInputState = /** @class */ (function (_super) {
    tslib_1.__extends(RadioInputState, _super);
    function RadioInputState(label, group) {
        var _this = _super.call(this, label) || this;
        _this.group = group;
        if (RadioInputState.inputGroups[group] == null) {
            RadioInputState.inputGroups[group] = [_this];
        }
        else {
            RadioInputState.inputGroups[group].push(_this);
        }
        return _this;
    }
    RadioInputState.prototype.setValue = function (val) {
        _super.prototype.setValue.call(this, val);
        if (val) {
            var inputs = RadioInputState.inputGroups[this.group];
            for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
                var input = inputs_1[_i];
                if (input !== this) {
                    input.setValue(false);
                }
            }
        }
    };
    RadioInputState.inputGroups = {};
    return RadioInputState;
}(input_state_1.InputState));
exports.RadioInputState = RadioInputState;
//# sourceMappingURL=radio.input.state.js.map